export var formatShortMonthFRCA = function (value, date) {
    var monthNumber = date.getMonth();
    var monthsLength = [3, 3, 4, 3, 3, 4, 3, 4, 3, 3, 3, 3];
    var monthLength = monthsLength[monthNumber];
    return value.slice(0, monthLength);
};
export var formatShortMonthESLA = function (value) { return value.slice(0, 3); };
//# sourceMappingURL=formatShortMonth.js.map